'use client';

import { Star, Heart, Users, Globe } from '@phosphor-icons/react';

const VALUES = [
  {
    icon: Star,
    title: 'Качество превыше всего',
    description: 'Мы не соглашаемся на сомнительную выгоду и спорные предложения. Наши роллы готовятся только из свежих и безопасных продуктов.',
    gradient: 'linear-gradient(135deg, #7B42FF 0%, #5B28D1 100%)',
    accent: '#7B42FF',
    photo: 'https://cdn.aziatochka.ru/aziatochka/02.webp',
  },
  {
    icon: Heart,
    title: 'Забота и честность',
    description: '«Мне вкусно!» — то, ради чего мы работаем. Мы не застрахованы от ошибок, но всегда признаём их и максимально быстро исправляем.',
    gradient: 'linear-gradient(135deg, #8B5CF6 0%, #7B42FF 100%)',
    accent: '#8B5CF6',
    photo: 'https://cdn.aziatochka.ru/aziatochka/03.webp',
  },
  {
    icon: Users,
    title: 'Объединение единомышленников',
    description: '«Азиаточка» объединяет в своём пространстве тех, кто трудится для людей, и тех, кто ценит идею.',
    gradient: 'linear-gradient(135deg, #7C3AED 0%, #A78BFA 100%)',
    accent: '#7C3AED',
    photo: 'https://cdn.aziatochka.ru/aziatochka/06.webp',
  },
  {
    icon: Globe,
    title: '«Азиаточка» — каждому',
    description: 'Мы стремимся к созданию сети локаций, где вкусные роллы, современные технологии, крутой дизайн и добро доступны каждому.',
    gradient: 'linear-gradient(135deg, #5B28D1 0%, #7B42FF 100%)',
    accent: '#5B28D1',
    photo: 'https://cdn.aziatochka.ru/aziatochka/08.webp',
  },
];

export function AboutValues() {
  return (
    <section className="py-20 sm:py-32 relative overflow-hidden">
      <div className="blur-blob absolute -top-20 right-0 w-[500px] h-[500px] rounded-full bg-[var(--primary)]/5 blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-16 sm:mb-24">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-black tracking-tight text-[var(--text-primary)] leading-[0.95] mb-6 animate-fade-up">
            Наши <span className="text-[var(--primary)]">ценности</span>
          </h2>
          <p className="text-lg sm:text-xl text-[var(--text-secondary)] leading-relaxed max-w-2xl mx-auto animate-fade-up" style={{ animationDelay: '160ms' }}>
            То, что стоит за каждым нашим роллом
          </p>
        </div>

        {/* 2x2 grid — cards with photo */}
        <div className="grid sm:grid-cols-2 gap-5 sm:gap-6">
          {VALUES.map((value, i) => {
            const Icon = value.icon;
            return (
              <div
                key={value.title}
                className="animate-fade-up group"
                style={{ animationDelay: `${i * 100}ms` }}
              >
                <div className="about-value-card relative rounded-3xl bg-[var(--surface-primary)] border border-[var(--border-default)] overflow-hidden h-full transition-all duration-500 hover:shadow-2xl hover:shadow-[var(--primary)]/8 hover:-translate-y-1 hover:border-[var(--border-hover)]">
                  {/* Photo top */}
                  <div className="relative aspect-[16/9] overflow-hidden">
                    <img
                      src={value.photo}
                      alt={value.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      loading="lazy"
                    />
                    {/* Gradient overlay bottom */}
                    <div className="absolute inset-0 bg-gradient-to-t from-[var(--surface-primary)] via-transparent to-transparent" />
                    {/* Icon badge */}
                    <div
                      className="absolute bottom-4 left-6 w-12 h-12 rounded-xl flex items-center justify-center shadow-lg transition-transform duration-500 group-hover:scale-110"
                      style={{ background: value.gradient, boxShadow: `0 8px 24px ${value.accent}30` }}
                    >
                      <Icon weight="fill" className="w-6 h-6 text-[var(--text-on-primary)]" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6 sm:p-8">
                    <h3 className="text-xl sm:text-2xl font-bold text-[var(--text-primary)] mb-3 group-hover:text-[var(--primary)] transition-colors duration-300">
                      {value.title}
                    </h3>
                    <p className="text-sm sm:text-base text-[var(--text-secondary)] leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
